module.exports = __webpack_public_path__ + "static/media/bsc.5f8b983f.png";